const data = {
  gasSelected: 0,
  language: 'EN',
  network: 'ethereum',
  account: '',
};

export { data };
